import styled from 'styled-components'
import { COLOURS } from 'resources'

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
`

export const Logo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
  margin-right: 12px;
  margin-bottom: 5px;
  background-color: ${COLOURS.neutralWhite};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export const TitleText = styled.div`
  font-family: 'EBGaramond', sans-serif;
  font-weight: 600;
  font-size: 16px;
`

export const DatePill = styled.div`
  font-family: 'EBGaramond', sans-serif;
  font-size: 10px;
  background-color: ${COLOURS.paleYellow};
  color: ${COLOURS.systemOrange1};
  min-height: 12px;
  min-width: 32px;
  border-radius: 9999px;
  border: 1px solid ${COLOURS.yellow};
  padding: 1px 6px;
`

export const DetailsContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const DetailsText = styled.span`
  font-family: 'EBGaramond', sans-serif;
  font-size: 12px;
  white-space: pre-wrap;
`

export const RecordsText = styled(DetailsText)`
  font-weight: 800;
`
